import React from 'react'
import { useTranslation } from 'react-i18next'
import { IconS24Folder24 } from '@is24/cosma-ui-icons'
import ScreenContainer from '../../../../common/containers/screenContainer/ScreenContainer'
import { SCREEN_TENANT_DOCUMENTS, SCREENS } from '../../../../../services/domain/wizardScreens'
import TenantDocumentsGroup from './fields/tenantDocumentsGroup'
import { getTenantDocuments } from '../../../../../services/domain/getTenantDocuments'
import { allTenantDocuments } from '../../../../../services/domain/TenantDocuments'
import { InsertionFlowScreensProps } from '../../../../../@types/props-types'
import { AbstractScreenValidationResult } from '../../../../../@types/validation-types'
import { ScreenLayout } from '../../../../common/containers/screenLayout/ScreenLayout'

const screen = SCREENS[SCREEN_TENANT_DOCUMENTS]

const TenantDocumentsScreen: React.FC<InsertionFlowScreensProps<AbstractScreenValidationResult>> = (props) => {
  const { t } = useTranslation()

  return (
    <ScreenContainer containerId={screen.id} onNavigate={props.onNavigate} screen={screen}>
      <ScreenLayout
        id={`${screen.id}-desk-tooltip`}
        headline={'wizard.screen.tenantDocuments.header'}
        headerIcon={<IconS24Folder24 />}
        screenName={screen.name}
      >
        <div className='margin-bottom-m'>
          <div className='grid-flex'>
            <div className='font-body-small-regular'>
              <p>
                {t(
                  'wizard.screen.tenantDocuments.screenDescription',
                  'Choose the documents, which you want from the applicant'
                )}
              </p>
            </div>
          </div>
        </div>
        <div>
          <TenantDocumentsGroup
            {...props}
            screenName={screen.name}
            tenantDocuments={getTenantDocuments(props.insertionData, allTenantDocuments)}
          ></TenantDocumentsGroup>
        </div>
      </ScreenLayout>
    </ScreenContainer>
  )
}

export default TenantDocumentsScreen
